'use client'
import React, {useState} from 'react';
import {Form, notification} from "antd";
import Input from "@/app/components/form-fields/input/Input";
import classes from "@/app/[locale]/(main)/(reset-password)/forgot-password/form/ForgotPasswordForm.module.scss";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import {useTranslation} from "react-i18next";
import {forgotPassword} from "@/app/actions/formActions";

function ForgotPasswordForm(props) {
    const [form] = Form.useForm();
    const {t} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [api, contextHolder] = notification.useNotification();

    const openNotification = (type, placement, text) => {
        api[type]({
            message: `${type === 'error' ? t('notifications.error') : t('notifications.success')}`,
            description: text,
            placement,
        });
    };

    return (<div className={classes.resetPassword}>
        {contextHolder}
        <Form
            onFinish={(values) => {
                setLoading(true)
                forgotPassword(values).then((status) => {
                    setLoading(false)
                    if (status >= 200 && status <= 299) {
                        form.resetFields();
                        openNotification('success', 'bottomRight', t('notifications.emailSent'))
                    } else if (status === 422) {
                        openNotification('error', 'bottomRight', t('notifications.emailNotExisting'))
                    }else if (status === 403) {
                        openNotification('error', 'bottomRight', t('notifications.cantResetPassword'))
                    } else {
                        openNotification('error', 'bottomRight', t('notifications.serverError'))
                    }
                })
            }}
            className={classes.form}
        >
            <Form.Item
                name="email"
                rules={[{
                    required: true, message: t('validation.emailRequired'),
                }, {
                    type: "email", message: t('validation.emailFormat'),
                }, {
                    max: 320, message: t('validation.emailMaxLength'),
                },]}
            >
                <Input placeholder={t('placeholders.email')}/>
            </Form.Item>
            <RoundedButton
                type="primary"
                htmlType="submit"
                className={classes.sendBtn}
                loading={loading}
            >
                {t('buttons.send')}
            </RoundedButton>
        </Form>
    </div>);
}

export default ForgotPasswordForm;